var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hero'),_c('v-container',{staticClass:"py-5 px-0",attrs:{"fluid":""}},[_c('who-i-am'),_c('what-i-can-do-for-you'),_c('where-ive-been'),_c('what-i-know'),_c('what-ive-done'),_c('what-my-clients-say'),_c('lets-talk')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }